const LoadReactiveSearch = {
  reactiveSearchLoaded: false,

  setEvents: function () {
    const { addScript } = LoadReactiveSearch;
    const searchButton = document.querySelector('[data-action="show-form-reactive-search"]');
    const formSearchInput = document.querySelector('.search-form-reactive-search .reactive-search-input');

    //Se a busca for aberta pelo click no botão
    if (searchButton) {
      searchButton.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          addScript();
        },
        { once: true }
      );
      //Se a busca estiver diretamente no header
    } else if (formSearchInput) {
      formSearchInput.addEventListener(
        'focus',
        (event) => {
          event.preventDefault();
          addScript();
        },
        { once: true }
      );
    }
  },

  addScript: function () {
    if (!LoadReactiveSearch.reactiveSearchLoaded) {
      const scriptEl = document.createElement('script');
      scriptEl.src = window.reactiveSearchScript;
      document.body.appendChild(scriptEl);

      LoadReactiveSearch.reactiveSearchLoaded = true;
    }
  },

  init: function () {
    const _this = this;

    _this.setEvents();
  },
};

export default LoadReactiveSearch;
